import { Injectable, inject } from '@angular/core';
import { Observable, from, map } from 'rxjs';
import {
  Auth,
  authState,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  GoogleAuthProvider,
  User as FirebaseUser,
  UserCredential,
} from '@angular/fire/auth';
import { AuthApi, User } from '@dges/modules/auth/domain';

@Injectable({
  providedIn: 'root',
})
export class FirebaseAuthService implements AuthApi {
  private auth = inject(Auth);

  user$: Observable<User | null> = authState(this.auth).pipe(
    map((u) => (u ? this.toUser(u) : null)),
  );

  login(email: string, password: string): Observable<User> {
    return from(signInWithEmailAndPassword(this.auth, email, password)).pipe(
      map((cred) => this.toUser(cred.user)),
    );
  }

  loginWithGoogle(): Observable<User> {
    return from(signInWithPopup(this.auth, new GoogleAuthProvider())).pipe(
      map((cred: UserCredential) => this.toUser(cred.user)),
    );
  }

  logout(): Observable<void> {
    return from(signOut(this.auth));
  }

  private toUser(u: FirebaseUser): User {
    return {
      uid: u.uid,
      email: u.email ?? '',
      displayName: u.displayName ?? '',
      photoURL: u.photoURL ?? undefined,
    };
  }
}
